const usePermissionConfig = () => {
  return {
    // 消息重试
    XXCS: 'OPS-XXZX-XXGL-XXCS',
    // 消息详情
    XXXQ: 'OPS-XXZX-XXGL-XXXQ',
    // 消息日志
    XXRZ: 'OPS-XXZX-XXGL-XXRZ',
  };
};

export default usePermissionConfig;
